import {
    RegionsEnum,
    CheckoutPageEuQuery,
    CheckoutPageApQuery,
    CheckoutPageAmQuery,
    CheckoutPageEuQueryVariables,
    CheckoutPageApQueryVariables,
    CheckoutPageAmQueryVariables,
    CheckoutPageEuDocument,
    CheckoutPageApDocument, CheckoutPageAmDocument,
} from 'src/generated/operations.ts';
import { removeDuplicateFragments } from 'src/utils/de-dupe-fragments.ts';
import { DocumentNode } from 'graphql/language/ast';
import { FilterConfig } from 'src/utils/composeFilter.ts';
import { getActuatorsPageConfig } from 'src/modules/actuators/ActuatorsPageMapping.ts';

export type CheckoutPageData = Omit<
CheckoutPageEuQuery | CheckoutPageApQuery | CheckoutPageAmQuery,
'__typename'
>;
export type CheckoutPageVariables = Omit<
CheckoutPageEuQueryVariables | CheckoutPageApQueryVariables | CheckoutPageAmQueryVariables, '__typename'
>;

export type ComboData = CheckoutPageData['vssCombo']['0'];
export type ValveData = CheckoutPageData['vssAccessories']['valve'];
export type ActuatorData = CheckoutPageData['vssAccessories']['actuator'];

export type CheckoutPageConfig = {
    mainFilterConfig: FilterConfig;
    query: DocumentNode;
    actuatorsFilterConfig: FilterConfig;
    additionalFilterConfig: FilterConfig;
}

export const getCheckoutPageConfig = (region: RegionsEnum): CheckoutPageConfig | null => {
    const actuatorsPageConfig = getActuatorsPageConfig(region);
    if (actuatorsPageConfig === null) {
        throw new Error('No Valves Page Config');
    }
    const {
        mainFilterConfig,
        additionalFilterConfig,
        filterConfig: actuatorsFilterConfig,
    } = actuatorsPageConfig;
    if (region === RegionsEnum.Eu) {
        return {
            query: removeDuplicateFragments(CheckoutPageEuDocument),
            actuatorsFilterConfig,
            mainFilterConfig,
            additionalFilterConfig,
        };
    }
    if (region === RegionsEnum.Ap) {
        return {
            query: removeDuplicateFragments(CheckoutPageApDocument),
            actuatorsFilterConfig,
            mainFilterConfig,
            additionalFilterConfig,
        };
    }
    if (region === RegionsEnum.Am) {
        return {
            query: removeDuplicateFragments(CheckoutPageAmDocument),
            actuatorsFilterConfig,
            mainFilterConfig,
            additionalFilterConfig,
        };
    }
    return null;
};
